import type { PrefabData } from "./prefabData";
import { GraySlab } from "../../things/floors/graySlab.ts";

export const bigContainerData: PrefabData = {
	legend: {
		B: "BigContainer",
	},
	layout: ["B"],
};

export const powerPlantSwitchPrefabData: PrefabData = {
	borderRequired: true,
	legend: {
		".": GraySlab.key,
		"#": "MetalBlock",
		"X": "PowerPlantSwitch",
		M: "MachineRack",
		"@": "ConcreteBlock",
	},
	layers: [
		[
			"       ",
			" ..@.. ",
			" ..... ",
		],
		[
			"#######",
			"#MMXMM#",
			"       ",
		]
	]
};
